import React from "react";
import { IconButton } from "@mui/material";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";

const FilterButton = ({ onClick, sx = {}, ...props }) => {
  return (
    <IconButton
      sx={{
        color: "#fff",
        // width: "30px",
        // height: "30px",
        borderRadius: "4px",
        opacity: 1,
        border: "1px solid #47A06C",
        "&:hover": {
          border: "1px solid #47A06C",
        },
        ...sx,
      }}
      onClick={onClick}
      {...props}
    >
      <FilterAltOutlinedIcon
        sx={{
          color: "#47A06C",
          "&:hover": {
            color: "#47A06C",
          },
        }}
      />
    </IconButton>
  );
};

export default FilterButton;
